import { useSelector } from 'react-redux';
import moment from 'moment';
import AvailabilityRequest from '../components/AvailabilityRequest';
import { RootState } from '../../../config/redux/types';

export default function AvailabilityRequestContainer(): JSX.Element | null {
  const routes = useSelector((state: RootState) => state.routes);

  const accommodationId = routes.host?.accommodation?.id;

  if (accommodationId == null) {
    return null;
  }
  const minDate = moment();

  return <AvailabilityRequest accommodationId={accommodationId} minDate={minDate} />;
}
